import { Grid, LinearProgress, Container } from "@material-ui/core";
import React, { useEffect } from "react";
import Filters from "../components/Filters";
import PublicationsTable from "../components/PublicationsTable";
import { search } from "../restAPI/v1/Publications";
import { useStore } from "../store/Store";

interface IState {
  loading: boolean;
  searchResults: Array<System.Publication>;
  headingText: string;
  paginationInfo: System.PaginationInfo;
}

const MainPage = (props: any) => {
  const { state } = useStore();
  const [localState, setLocalState] = React.useState<IState>({
    loading: true,
    searchResults: [],
    headingText: "Loading publications...",
    paginationInfo: {
      totalDocs: 0,
      limit: 5,
      page: 1,
    },
  });

  const thisSearch = async (isFromPaginationInfo: boolean) => {
    if (localState.paginationInfo.page !== 1) {
      setLocalState({
        ...localState,
        paginationInfo: { ...localState.paginationInfo, page: 1 },
      });
    } else {
      performSearch();
    }
  };
  const performSearch = async () => {
    setLoading(true);
    search(state.filterQuery, localState.paginationInfo)
      .then((e) => {
        setLocalState({
          ...localState,
          paginationInfo: {
            ...localState.paginationInfo,
            totalDocs: e.data.count,
          },
          loading: false,
          searchResults: e.data.rows,
          headingText:
            e.data.count > 0
              ? "Browse " + e.data.count + " publications"
              : e.data.count + " publications found",
        });
      })
      .catch((e) => {
        const searchResults: System.Publication[] = [];
        setLocalState({
          ...localState,
          searchResults: searchResults,
          loading: false,
          headingText:
            searchResults.length > 0
              ? "Browse " +
                localState.paginationInfo.totalDocs +
                " publications"
              : searchResults.length + " publications found",
        });
      });
  };
  useEffect(() => {
    performSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localState.paginationInfo.limit, localState.paginationInfo.page]);

  const updatePaginationInfo = (newPaginationInfo: System.PaginationInfo) => {
    setLocalState({ ...localState, paginationInfo: newPaginationInfo });
  };

  const setLoading = (loading: boolean) => {
    setLocalState({ ...localState, loading: loading });
  };

  return (
    <Container style={{ marginBottom: "4em", marginTop: "1em" }}>
      <p>
        * The creation of this database was an integral part of the work with
        the following publication:{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://doi.org/10.1088/1361-648X/ab9565"
        >
          J. Schnadt, J. Knudsen and N. Johansson, J. Phys.: Condens. Matter 32
          (2020) 413003
        </a>
        . Please refer to both this publication and the address of this webpage
        when referring to the database.
      </p>
      <Grid item xs={12} className="text-align-center">
        <span className="main-page-total-publications">
          {localState.headingText}
        </span>
      </Grid>
      <div style={{ height: "1.5em" }}></div>
      <Filters
        updatePaginationInfo={updatePaginationInfo}
        search={(isFromPaginationInfo: boolean) =>
          thisSearch(isFromPaginationInfo)
        }
      />
      <LinearProgress
        color="primary"
        className={localState.loading ? "show" : "hide"}
      />
      <PublicationsTable
        data={localState.searchResults}
        paginationInfo={localState.paginationInfo}
        updatePaginationInfo={updatePaginationInfo}
      />
    </Container>
  );
};

export default MainPage;
